/* eslint-disable no-undef */
(function(){
    angular.module('tmx-app').factory('EncryptionService', ['tmxResource', function(tmxResource){
    
        var Encryption = tmxResource("Encryption");      

        Encryption.encrypt = function(pass, key, iv) {
            key = CryptoJS.enc.Utf8.parse(key);  
            iv = CryptoJS.enc.Utf8.parse(iv);  
            var encryptedlogin = CryptoJS.AES.encrypt(pass, key,  
                {   
                    iv: iv,  
                    mode: CryptoJS.mode.CBC,  
                    padding: CryptoJS.pad.Pkcs7  
                });
            
            // salt, iv will be hex 32 in length
            // append them to the ciphertext for use  in decryption
            var transitmessage = encryptedlogin.toString();
            return transitmessage;
        }

        return Encryption;

    }]);
})();